// import can from '@/router/middleware/can'

import auth from '../../middleware/auth'

export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ '@/pages/dashboard/DashboardIndex'
      ),
    meta: {
      // TODO: add can middleware
      middleware: [auth],
      title: 'dashboard',
      breadCrumb: [{ text: 'dashboard' }]
    }
  }
  //   {
  //     path: '/dashboard/:dashboardId',
  //     name: 'DashboardShow',
  //     component: () =>
  //       import(
  //         /* webpackChunkName: "dashboardShow" */ '@/pages/dashboard/DashboardShow'
  //       ),
  //     props: true,
  //     meta: {
  //       middleware: [can('isDashboardShow'), auth],
  //       title: 'dashboard',
  //       breadCrumb: [
  //         { text: 'dashboard', to: { name: 'Dashboard' } },
  //         { text: undefined }
  //       ]
  //     }
  //   }
]
